import type { IBrand } from '../../types';
import { getPortfolioBrandUrl } from '../../constants/portfolioLinks';

interface BrandsSectionProps {
  brands?: IBrand[];
  isLoading: boolean;
}

const brandLogos: Record<string, string> = {
  'Veep Capital':  '/brand_logos/veepcapital.png',
  'Nova Era Labs': '/brand_logos/novaera-era-labs.png',
  'OmniHealthX':  '/brand_logos/omnihealth.png',
  'VruddhiX':     '/brand_logos/Vruddhix.png',
  'Pixentro':     '/brand_logos/pixentro.png',
  'CapSeriesX':   '/brand_logos/capseriesx.png',
  'DevRaise':     '/brand_logos/devraise.png',
};

function getLogo(name: string) {
  return brandLogos[name] ?? null;
}

function isFlagship(brand: IBrand) {
  return brand.name === 'Veep Capital';
}

export default function BrandsSection({ brands, isLoading }: BrandsSectionProps) {
  const items = brands ?? [];

  return (
    <section id="brands" className="brands-section">
      <div className="brands-section-header">
        <div>
          <div className="eyebrow-label">Brand Ventures</div>
          <h2>Four Ventures. <span style={{ color: 'var(--gold)', fontStyle: 'italic' }}>Four Markets.</span></h2>
        </div>
        <div>
          <p className="lead">
            Each Apex brand venture targets a distinct capital market vertical — collectively creating a comprehensive ecosystem for the tokenized economy.
          </p>
        </div>
      </div>

      <div className="brand-grid">
        {isLoading
          ? Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="brand-card" style={{ minHeight: 220 }} />
            ))
          : items.map((brand) => {
              const url = getPortfolioBrandUrl(brand);
              const logo = getLogo(brand.name);
              return (
                <div key={brand._id} className="brand-card">
                  <div className="brand-card-inner">
                    <div className="bc-icon">
                      {logo
                        ? <img src={logo} alt={brand.name} className="bc-logo-img" />
                        : <span>{brand.name.slice(0, 2).toUpperCase()}</span>
                      }
                    </div>
                    <div style={{ flex: 1 }}>
                      <div className="bc-name">{brand.name}</div>
                      <div className="bc-tag">{brand.tag}</div>
                      <div className="bc-text">{brand.description}</div>
                      {isFlagship(brand) && (
                        <div className="bc-badge">✦ Flagship · VYASA Platform</div>
                      )}
                      {url && (
                        <a href={url} target="_blank" rel="noopener noreferrer" className="brand-link">
                          Visit Website →
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    </section>
  );
}
